module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/hunt_auth_success.074fa480.png";